const headers = new Headers();
headers.append('Accept-Language', document.querySelector('html')!.lang);
headers.append('Content-Type', 'application/json');

export const BankAccountService = {
    async checkBankAccount(iban: string, kboNumber: string): Promise<boolean> {
        const response = await fetch('api/FondsRebond/CheckCompteBancaire', {
            method: 'POST',
            body: JSON.stringify({
                iban: iban,
                numeroEntreprise: kboNumber,
            }),
            headers,
        });

        return response.json() as Promise<boolean>;
    },
};
